import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { PATHS } from '../../constants/Paths.constants';
import { useAppDispatch, useAppSelector } from '../../hooks/redux';
import { authService } from '../../services/AuthService';
import { logout } from '../../store/slices/authSlice';
import { selectIsSuperAdmin } from '../../store/selectors/authSelectors';
import { getUserInitials, logoutAndClearStorage } from '../../utils/Auth.util';
import { Notifications } from '../features/Notifications/Notifications';
import { Support } from '../features/Support/Support';
import { isOidcAuth } from '../../config/featureFlags';

export function Header() {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const { user } = useAppSelector((state) => state.auth);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const isSuperAdminRole = useAppSelector(selectIsSuperAdmin);
  const showNotifications = !isSuperAdminRole;

  const handleLogout = async () => {
    if (isOidcAuth()) {
      navigate(PATHS.LOGOUT);
      return;
    }

    // Local auth path
    try {
      await authService.logout();
      dispatch(logoutAndClearStorage());
      navigate(PATHS.LOGIN);
    } catch (error) {
      console.error('Logout failed:', error);
      dispatch(logout());
      navigate(PATHS.LOGIN);
    }
  };

  return (
    <header className="h-16 bg-white border-b border-gray-150 px-8 flex items-center justify-end">
      <div className="flex items-end justify-end gap-3">
        <Support />
        {showNotifications && <Notifications />}
        <div className="relative">
          <button
            onClick={() => setIsDropdownOpen(!isDropdownOpen)}
            className="flex items-center justify-center w-8 h-8 bg-purple-100 text-purple-700 text-sm font-medium hover:bg-purple-600 hover:text-white transition-colors duration-200 rounded-2xl"
          >
            {getUserInitials(user?.name)}
          </button>
          {isDropdownOpen && (
            <div className="absolute right-0 mt-2 w-48 bg-white rounded-md shadow-lg border border-gray-200 z-50">
              <button
                onClick={handleLogout}
                className="w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 transition-colors duration-200"
              >
                Logout
              </button>
            </div>
          )}
        </div>
      </div>
      {isDropdownOpen && (
        <div
          className="fixed inset-0 z-10"
          onClick={() => setIsDropdownOpen(false)}
        />
      )}
    </header>
  );
}
